import axios from 'axios';
import router from '@/router';
import qs from 'qs';
import { Toast } from 'vant';
import { disconnectUserSocket } from '@/utils/socket';

const TOKEN_KEY = 'user.token';
const TOKEN_EXPIRE_KEY = 'user.token.expire';
const DEFAULT_TOKEN_TTL = 12 * 60 * 60 * 1000;

// 开发走同源 /api，由 vue.config.js devServer 代理，避免跨域
// 打包后仍直连线上 API（devServer.proxy 不会打进 dist）
const API_BASE_URL = process.env.NODE_ENV === 'development'
    ? '/api/'
    : 'https://api.pc28sz.com/';

const request = axios.create({
    baseURL: API_BASE_URL,
    timeout: 30000,
});

function requestGet(url, params) {
    if(params && Object.keys(params).length !== 0) {
        url += '?' + qs.stringify(params);
    }
    console.log("request url:" + url);
    return request({
        url: url,
        method: 'GET'
    });
}

function requestPost(url, params) {
    console.log("request url:" + url);
    params = params && qs.stringify(params);
    return request({
        url: url,
        method: 'POST',
        data: params,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        }
    });
}

// 错误处理
const errorHandler = (error) => {
    if (error.response) {
        if (error.response.status === 403) {
            Toast.fail('你没有该权限');
        } else if(error.response.status === 404) {
            Toast.fail('资源不存在');
        } else if(error.response.status === 401) {
            disconnectUserSocket();
            removeToken();
            setTimeout(() => {
                Toast.fail('你还没有登录，或登录已过期');
                router.replace('/login');
            }, 500);
        } else if(error.response.status === 500) {
            console.error(error.response.data);
        }
    }
    return Promise.reject(error);
}

// 请求拦截器
request.interceptors.request.use(config => {
    const token = getToken();
    if(token) {
        config.headers['token'] = token;
    }
    return config;
}, errorHandler)

// 响应拦截器
request.interceptors.response.use((response) => {
    const res = response.data;
    res.isSucceed = res.code === '200' || res.code === 200;

    if (res.code === '401' || res.code === 401) {
        disconnectUserSocket();
        removeToken();
        Toast.fail(res.message || '登录已过期，请重新登录');
        router.replace('/login');
    }

    return res;
}, errorHandler);

function getToken() {
    return window.sessionStorage.getItem(TOKEN_KEY) || '';
}

function getTokenExpireAt() {
    const value = window.sessionStorage.getItem(TOKEN_EXPIRE_KEY);
    return value ? Number(value) : 0;
}

function setToken(token, expiresIn = DEFAULT_TOKEN_TTL) {
    window.sessionStorage.setItem(TOKEN_KEY, token);
    window.sessionStorage.setItem(TOKEN_EXPIRE_KEY, String(Date.now() + expiresIn));
    // 清掉旧版 localStorage，避免关页后仍被残留 token 影响
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(TOKEN_EXPIRE_KEY);
}

function isTokenExpired() {
    const token = getToken();
    if (!token) {
        return false;
    }
    const expireAt = getTokenExpireAt();
    return expireAt > 0 && Date.now() > expireAt;
}

function isAuthenticated() {
    const token = getToken();
    if (!token) {
        return false;
    }
    return !isTokenExpired();
}

function checkToken() {
    return isAuthenticated();
}

function removeToken() {
    window.sessionStorage.removeItem(TOKEN_KEY);
    window.sessionStorage.removeItem(TOKEN_EXPIRE_KEY);
    window.localStorage.removeItem(TOKEN_KEY);
    window.localStorage.removeItem(TOKEN_EXPIRE_KEY);
    disconnectUserSocket();
}

export {
    API_BASE_URL,
    request,
    requestGet,
    requestPost,
    getToken,
    setToken,
    checkToken,
    isAuthenticated,
    isTokenExpired,
    removeToken,
};
